import {useEffect} from 'react';

import {useLatest} from './useLatest';

// Uses the latest ref pattern https://epicreact.dev/the-latest-ref-pattern-in-react/

export default function useKeypresses(
    keyedCallbacks: Record<string, (event: KeyboardEvent) => unknown>
) {
    const latestKeyedCallbacks = useLatest(keyedCallbacks);

    useEffect(() => {
        const handleKeyPress = (e: KeyboardEvent) => {
            const userIsInTextInput =
                e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement;

            const keyCombo = e.metaKey ? `meta+${e.key}` : e.key;

            if (keyCombo in latestKeyedCallbacks.current && !userIsInTextInput) {
                e.preventDefault(); // prevent default behavior of the key combo e.g. meta+y usually opens the browser's history
                latestKeyedCallbacks.current[keyCombo](e);
            }
        };

        window.addEventListener('keydown', handleKeyPress);

        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, [latestKeyedCallbacks]);
}
